var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.b{fill:none;stroke:#97a6aa;stroke-linecap:round;stroke-width:1.5px;}.a{stroke-linejoin:round;}")),React.createElement("g",{"transform":"translate(4.702 3.75)","key":1},[React.createElement("g",{"transform":"translate(0 -3)","key":0},[React.createElement("path",{"className":"a","d":"M10,0,5,5,0,0","transform":"translate(0 9.558)","key":0}),React.createElement("line",{"className":"a","y1":"14.558","transform":"translate(5)","key":1})]),React.createElement("line",{"className":"b","x2":"18","transform":"translate(-3.952 17.279)","key":1})])]);
}

Download.defaultProps = {"width":"19.5","height":"21.779","viewBox":"0 0 19.5 21.779"};

module.exports = Download;

Download.default = Download;
